import React, { useEffect, useState, useRef } from "react"
import { htmlStringToReactElement } from "../../helpers/html"
import Svg from "../_svgs/svg"

const Item = ({
  item,
  hash,
  mopinionScript,
  handLuggageLabel,
  checkinLabel,
  scrollIntoView,
  setHash,
  amountShown,
  itemNumber,
  refProp,
  ariaLabelAllowed,
  ariaLabelSometimesAllowed,
  ariaLabelNotAllowed,
}) => {
  const itemRef = useRef(null)
  const contentWrapperRef = useRef(null)

  {
    /*   
    CPH-4956
    Needs a unique ID for aria-controls when working with accordions.
    Our react version is not new enough to have useId hook available, so we need to manually create an ID with useRef and a random number.
    */
  }
  const idRef = useRef(null)
  if (!idRef.current) {
    idRef.current = `item-${Math.random().toString(36).substr(2, 9)}`
  }
  const contentId = `${idRef.current}-content`

  const [itemOpen, setItemOpen] = useState(false)

  const handleAccordion = () => {
    setItemOpen(!itemOpen)
  }

  // Manage focusability/inertness of content when open/closed
  useEffect(() => {
    const content = contentWrapperRef.current
    if (content) {
      content.inert = !itemOpen
      content.setAttribute("aria-hidden", (!itemOpen).toString())
    }
  }, [itemOpen])

  const openAccordionFromAnchor = () => {
    const accordion = itemRef.current
    if (accordion) {
      const accordionTrigger = accordion.querySelector(".itemtable")
      if (accordionTrigger) {
        if (!accordionTrigger.classList.contains("is-active")) setItemOpen(true)

        if (scrollIntoView) scrollIntoView(accordion)
      }
    }
  }

  const handleHash = (hash) => {
    if (item.anchorId && hash === item.anchorId) {
      requestAnimationFrame(() => {
        openAccordionFromAnchor()
      })
    }
    if (setHash) {
      setHash(hash)
    }
  }

  const handleTouchStart = (target) => {
    let parent = target.parentElement
    parent.classList.add("touched")
  }

  const handleTouchEnd = (target) => {
    let parent = target.parentElement
    parent.classList.remove("touched")
  }

  useEffect(() => {
    if (hash) {
      handleHash(hash)
    }
  }, [hash])

  const getAriaLabel = (logo, label) => {
    switch (logo) {
      case "yes-icon":
        return ariaLabelAllowed.replace("{type}", label)
      case "maybe-icon":
        return ariaLabelSometimesAllowed.replace("{type}", label)
      case "no-icon":
        return ariaLabelNotAllowed.replace("{type}", label)
      default:
        return ""
    }
  }

  return (
    <li ref={itemRef} className={`item-list-item ${itemNumber > amountShown ? "is-hidden" : ""}${" " + itemNumber}`}>
      <button
        ref={refProp}
        className={`button itemtable ${item.info ? "" : "no-info"}`}
        aria-expanded={itemOpen}
        aria-controls={contentId}
        id={item.anchorId}
        onClick={item.info ? (e) => handleAccordion(e, ".contentWrapper") : undefined}
        onTouchStart={(e) => handleTouchStart(e.currentTarget)}
        onTouchEnd={(e) => handleTouchEnd(e.currentTarget)}
      >
        <div className={`iteminfo${itemOpen ? " is-active" : ""}`}>
          <div className="title" dangerouslySetInnerHTML={{ __html: item.title }}></div>
          <div className="handLuggage" aria-label={getAriaLabel(item.handLuggageLogo, handLuggageLabel)}>
            <Svg iconName={item.handLuggageLogo} stroke={"#FFF"} fillColor={item.handLuggageLogoColor} isDecorative={true} />
            <span aria-hidden="true">{handLuggageLabel}</span>
          </div>
          <div className="checkin" aria-label={getAriaLabel(item.checkinLogo, checkinLabel)}>
            <Svg iconName={item.checkinLogo} stroke={"#FFF"} fillColor={item.checkinLogoColor} isDecorative={true} />
            <span aria-hidden="true">{checkinLabel}</span>
          </div>
        </div>
      </button>

      {item.info ? (
        <div
          id={contentId}
          className={`contentWrapper show-hide ${!itemOpen ? "v-hidden" : ""}`}
          style={{ height: itemOpen ? contentWrapperRef.current.scrollHeight + "px" : "0px" }}
          ref={contentWrapperRef}
        >
          <span className="info-text" dangerouslySetInnerHTML={{ __html: item.info }}></span>
          {mopinionScript ? htmlStringToReactElement(mopinionScript) : ""}
        </div>
      ) : (
        ""
      )}
    </li>
  )
}

export default Item
